require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[52],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(459);


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Select = _interopRequireDefault(__webpack_require__(460));

exports["default"] = _Select["default"];
exports.Select = _Select["default"];

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

__webpack_require__(461);

var _StringResource = _interopRequireDefault(__webpack_require__(463));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var DEFAULT_LABEL = _StringResource["default"].get('selectOption');

var Select = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(Select, _PureComponent);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toolkitOnChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options;
      var value = e.target.value;
      var index = options.findIndex(function (o) {
        return String(o.value) === value;
      });
      var option = options[index];
      onChange && onChange(option.value, option.label, index);
    });
    return _this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    // destructuring unused props so that they can be ignored
    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        hideLabel = _this$props2.hideLabel,
        labelText = _this$props2.labelText,
        size = _this$props2.size,
        value = _this$props2.value,
        active = _this$props2.active,
        _this$props2$customWi = _this$props2.customWidth,
        customWidth = _this$props2$customWi === void 0 ? '100%' : _this$props2$customWi,
        displayLabel = _this$props2.displayLabel,
        grouped = _this$props2.grouped,
        hover = _this$props2.hover,
        icon = _this$props2.icon,
        intent = _this$props2.intent,
        label = _this$props2.label,
        options = _this$props2.options,
        readOnly = _this$props2.readOnly,
        selected = _this$props2.selected,
        showAllList = _this$props2.showAllList,
        textDir = _this$props2.textDir,
        truncated = _this$props2.truncated,
        variableClassName = _this$props2.variableClassName,
        variant = _this$props2.variant,
        otherCarbonSelectProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["children", "className", "disabled", "hideLabel", "labelText", "size", "value", "active", "customWidth", "displayLabel", "grouped", "hover", "icon", "intent", "label", "options", "readOnly", "selected", "showAllList", "textDir", "truncated", "variableClassName", "variant"]);
    var defaultValue = this.props.defaultValue; // remap className

    var mappedClassName = (className != null ? className : '') + " ba-toolkit-select-compat"; // remap disabled

    var mappedDisabled = disabled != null ? disabled : readOnly; // remap labelText

    var mappedLabelText = labelText != null ? labelText : label; // remap hideLabel

    var mappedHideLabel = (hideLabel != null ? hideLabel : mappedLabelText === undefined) ? true : undefined; // remap onChange

    var mappedOnChange = children ? onChange : this.toolkitOnChange; // remap size

    var mappedSize = size === 'small' ? 'sm' : size === 'normal' ? undefined : size; // remap value

    var mappedValue = value != null ? value : selected; // remap children / options

    var mappedChildren = children;

    if (!mappedChildren) {
      if (!grouped) {
        mappedChildren = (options || []).map(function (_ref) {
          var label = _ref.label,
              otherSelectItemProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["label"]);
          return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectItem, (0, _extends2["default"])({
            text: label
          }, otherSelectItemProps));
        });
      } else {
        // attempts to mimic toolkit grouped behavior in carbon
        mappedChildren = (options || []).reduce(function (groups, _ref2, i) {
          var label = _ref2.label,
              group = _ref2.group,
              otherSelectItemProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["label", "group"]);

          var option = /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectItem, (0, _extends2["default"])({
            text: label
          }, otherSelectItemProps)); // if we don't have a group we push the option directly


          if (group == null) {
            groups.push(option);
          } else if (i === 0 || group !== options[i - 1].group) {
            // if it's our first entry or we've entered a new group
            groups.push(group ? /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectItemGroup, {
              label: group
            }, option) : option);
          } else {
            // otherwise we're in the same group, add the option to the children of the previous group
            var element = groups[groups.length - 1];
            groups[groups.length - 1] = _react["default"].cloneElement(element, {
              children: [].concat(_react["default"].Children.toArray(element.props.children), [option])
            });
          }

          return groups;
        }, []);
      }
    } // Adding a DEFAULT_LABEL entry to the mappedChildren if one does not already exist and one is needed.
    // This is non-Carbon.
    // Carbon expects clients to fill out all the children(CarbonSelectItem) nodes.


    if (this.state.defaultSelectItem) {
      // If we've injected a default option, continue to inject it.
      // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.
      mappedChildren.unshift(this.state.defaultSelectItem);
    } else {
      var defaultOption = defaultValue != null ? defaultValue : mappedValue;

      if (!children && (!defaultOption || (options || []).every(function (o) {
        return o.value !== defaultOption;
      }))) {
        /*
         * In order to mimic old functionality, we create a hidden option with
         * content of as the text and bogus '__displayLabel__' as the value.
         * The option is inserted at the beginning of the options.
         * Since the option is hidden, it can never be selected, but visually achieves
         * the trick of a display label (e.g. 'Select an option').  Consumers may need to revisit down the
         * road and support this by supplying their own 'display label' as part of the 'options'.
         */
        var defaultSelectItem = /*#__PURE__*/_react["default"].createElement(_baUiCarbon.SelectItem, {
          value: defaultOption != null ? defaultOption : '__displayLabel__',
          text: displayLabel != null ? displayLabel : DEFAULT_LABEL,
          hidden: true
        }); // insert at beginning, if no defaultOption set first entry is always shown


        mappedChildren.unshift(defaultSelectItem); // If we've injected a default option, save it in case it needs to be injected later.
        // Changing the number of CarbonSelectItems leads to mismatched IDs -> Items in the select.

        this.setState({
          defaultSelectItem: defaultSelectItem
        });
      }
    } // Carbon Select does not honor the style={{ width: 'someWidth' }} prop
    // To address this we need to apply width to a few spots within the Carbon Select widget.
    // This is really hokey.
    // Carbon bug: https://github.com/carbon-design-system/carbon/issues/7259
    //
    // <div class="bx-form-item" >
    // 	// need to apply width="100%" to this div to stretch the select to match its parents width (done in the scss file)
    // 	<div class="bx--select ba-toolkit-select-compat">
    // 		<label>
    // 		// need to apply width="customWidth" to this div to make select the size the user wants (done here, apply to parent of bx--select-input)
    // 		<div class="bx--select-input__wrapper" >
    // 			// need to apply width="100%" and min-width="100%" to this select to stretch/shrink the select contents (done in the scss file)
    // 			<select class="bx--select-input"
    // 			<svg


    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Select, (0, _extends2["default"])({}, otherCarbonSelectProps, {
      className: mappedClassName,
      disabled: mappedDisabled,
      hideLabel: mappedHideLabel,
      labelText: mappedLabelText,
      onChange: mappedOnChange,
      ref: function ref(el) {
        el && el.parentNode.style.setProperty('width', customWidth);
      },
      size: mappedSize,
      value: mappedValue
    }), mappedChildren);
  };

  return Select;
}(_react.PureComponent);

exports["default"] = Select;
(0, _defineProperty2["default"])(Select, "__Select__", true);
(0, _defineProperty2["default"])(Select, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Select.propTypes, {
  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  active: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** deprecated - set style={width: 'in px or %', min-width: 'in px or %'} */
  customWidth: BaPropTypes.deprecated('deprecated - set style={width: "in px or %", min-width: "in px or %"}'),

  /** deprecated - no Carbon option */
  displayLabel: BaPropTypes.deprecated('deprecated - no Carbon option'),

  /** deprecated - supply children nested using the Carbon <SelectItemGroup> component */
  grouped: BaPropTypes.deprecated('deprecated - supply children nested using the Carbon <SelectItemGroup> component'),

  /** Deprecated (not applicable to Carbon Select): Passed as a prop to Select Button component */
  hover: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Icon diplayed inside the Select box */
  icon: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Sets the intent for Select box (Passed as a prop to Button component) */
  intent: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated: Label displayed at the top of Select. Use the carbon prop 'labelText' */
  label: BaPropTypes.deprecated(' is deprecated, use the carbon prop labelText'),

  /** deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit. */
  onChange: BaPropTypes.deprecated('deprecated(sort of) - used as Toolkit prop returns a non-standard signature(value,label,index), used as Carbon prop returns standard signature(event). If options are childern = Carbon, else toolkit.'),

  /** deprecated - pass menu items as children. As a toolkit prop Items can be grouped using 'group' prop. Note: grouped prop should be set to true to make grouping work */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape((0, _extends2["default"])({}, _baUiCarbon.SelectItem.propTypes, {
    group: _propTypes["default"].any,
    value: _propTypes["default"].any.isRequired,
    label: _propTypes["default"].string.isRequired
  }))).isRequired,

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN=== */
  selected: BaPropTypes.deprecated('deprecated - use value; if defining a default option ===IN CARBON THE CLIENT MUST ADD THE DEFAULT(undefined) "Select an option" ENTRY TO ITS CHILDREN==='),

  /** Deprecated (not applicable to Carbon Select): Display the entire list of items without the scrollbar */
  showAllList: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Text direction */
  textDir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): If set to true, dropdown items texts will be truncated */
  truncated: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Variable class names */
  variableClassName: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated (not applicable to Carbon Select): Sets the variant for Select box (Passed as a prop to Button component) */
  variant: BaPropTypes.deprecated(' is ignored and not applicable to carbon select')
}));

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(462);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-toolkit-select-compat{width:100%}.ba-toolkit-select-compat .bx--select-input{width:100%;min-width:100%}\n", ""]);

// exports


/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _SelectResources = _interopRequireDefault(__webpack_require__(464));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_SelectResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

var amdi18n={"__root":{"selectOption":"Select an option"},"__cs":{"selectOption":"Vybrat volbu"},"__da":{"selectOption":"Vælg en indstilling"},"__de":{"selectOption":"Option auswählen"},"__es":{"selectOption":"Seleccionar una opción"},"__fi":{"selectOption":"Valitse jokin vaihtoehto"},"__fr":{"selectOption":"Sélectionner une option"},"__hr":{"selectOption":"Izaberite opciju"},"__hu":{"selectOption":"Válasszon ki egy beállítást"},"__it":{"selectOption":"Seleziona un'opzione"},"__ja":{"selectOption":"オプションの選択"},"__kk":{"selectOption":"Параметрді таңдаңыз"},"__ko":{"selectOption":"옵션 선택"},"__nb":{"selectOption":"Velg et alternativ"},"__nl":{"selectOption":"Selecteer een optie"},"__no":{"selectOption":"Velg et alternativ"},"__pl":{"selectOption":"Wybierz opcję"},"__pt":{"selectOption":"Selecione uma Opção"},"__pt-br":{"selectOption":"Selecione uma Opção"},"__ro":{"selectOption":"Selectaţi o opţiune"},"__ru":{"selectOption":"Выбрать опцию"},"__sl":{"selectOption":"Izbira možnosti"},"__sv":{"selectOption":"Välj ett alternativ"},"__th":{"selectOption":"เลือกอ็อพชัน"},"__tr":{"selectOption":"Bir Seçenek belirleyin"},"__zh":{"selectOption":"选择选项"},"__zh-cn":{"selectOption":"选择选项"},"__zh-hk":{"selectOption":"選取選項"},"__zh-mo":{"selectOption":"選取選項"},"__zh-sg":{"selectOption":"选择选项"},"__zh-tw":{"selectOption":"選取選項"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[458,0]]]);
});